// Legacy redirect — the student team workspace moved to
// /student/competition/[id]/team on 2026-05-13. We keep this route alive
// so saved bookmarks, in-flight notifications, and email links from
// `team-join-approved`/etc. don't 404. The route looks up the team's
// competition id and forwards to the new path.
//
// Retire this file once log analytics confirm no traffic hits it
// (~3 months after the move).

import type { Href } from "expo-router";
import { Redirect, useLocalSearchParams } from "expo-router";
import { useEffect, useState } from "react";
import { ActivityIndicator, View } from "react-native";

import { supabase } from "../../../../lib/supabase";

export default function LegacyTeamRedirect() {
  const { id: teamId } = useLocalSearchParams<{ id: string }>();
  const [target, setTarget] = useState<Href | null>(null);

  useEffect(() => {
    if (!teamId) return;
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("teams")
        .select("competition_id")
        .eq("id", teamId)
        .maybeSingle();
      if (cancelled) return;
      const compId = (data as { competition_id?: string | null } | null)?.competition_id ?? null;
      if (compId) {
        setTarget(`/student/competition/${compId}/team` as Href);
      } else {
        // Team not found (deleted, wrong id) — bounce to the global list
        // instead of 404'ing.
        setTarget("/student/teams" as Href);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [teamId]);

  if (!target) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator />
      </View>
    );
  }

  return <Redirect href={target} />;
}
